<section class="container">
    <form [formGroup]="createAddressForm">
    <div class="row g-2 mt-2">
        <div class="col-md">
            <label for="floatingSelectGrid">Default this address for</label>
            <select class="form-select" id="select_address_type" formControlName="selectAddressType" required>
                <option value="0">Shipping</option>
                <option value="1">Billing</option>
                <option value="2">Designer</option>
            </select>

            <div class="validation-errors mb-2">
                <ng-container *ngFor="let validation of address_validation_messages.selectAddressType">
                  <div class="error-message" *ngIf="createAddressForm.get('selectAddressType')?.hasError(validation.type) && (createAddressForm.get('selectAddressType')?.dirty || createAddressForm.get('selectAddressType')?.touched)">
                    {{ validation.message }}
                  </div>
                </ng-container>
            </div>
        </div>
        <div class="col-md">
            <label for="company_name">Company name</label>
            <input type="text" class="form-control" id="company_name" placeholder="" formControlName="companyName" required>
            <div class="validation-errors mb-2">
                <ng-container *ngFor="let validation of address_validation_messages.companyName">
                  <div class="error-message" *ngIf="createAddressForm.get('companyName')?.hasError(validation.type) && (createAddressForm.get('companyName')?.dirty || createAddressForm.get('companyName')?.touched)">
                    {{ validation.message }}
                  </div>
                </ng-container>
            </div>
        </div>
    </div>

    <div class="row g-2 mt-2">
        <div class="col-md">
            <label for="first_name">First name</label>
            <input type="text" class="form-control" id="first_name" placeholder="" formControlName="firstName" required>
            <div class="validation-errors mb-2">
                <ng-container *ngFor="let validation of address_validation_messages.firstName">
                  <div class="error-message" *ngIf="createAddressForm.get('firstName')?.hasError(validation.type) && (createAddressForm.get('firstName')?.dirty || createAddressForm.get('firstName')?.touched)">
                    {{ validation.message }}
                  </div>
                </ng-container>
            </div>
        </div>
        <div class="col-md">
            <label for="last_name">Last name</label>
            <input type="text" class="form-control" id="last_name" placeholder="" formControlName="lastName" required>
            <div class="validation-errors mb-2">
                <ng-container *ngFor="let validation of address_validation_messages.lastName">
                  <div class="error-message" *ngIf="createAddressForm.get('lastName')?.hasError(validation.type) && (createAddressForm.get('lastName')?.dirty || createAddressForm.get('lastName')?.touched)">
                    {{ validation.message }}
                  </div>
                </ng-container>
            </div>
        </div>
    </div>
    <div class="row mt-2">
        <div class="col-md">
            <label for="address_email">Email</label>
            <input type="email" class="form-control" id="address_email" placeholder="" formControlName="addressEmail" required>
            <div class="validation-errors mb-2">
                <ng-container *ngFor="let validation of address_validation_messages.addressEmail">
                  <div class="error-message" *ngIf="createAddressForm.get('addressEmail')?.hasError(validation.type) && (createAddressForm.get('addressEmail')?.dirty || createAddressForm.get('addressEmail')?.touched)">
                    {{ validation.message }}
                  </div>
                </ng-container>
            </div>
        </div>
    </div>
    <div class="row mt-2">
        <div class="col-md">
            <label for="address_one">Address1</label>
            <input type="text" class="form-control" id="address_one" placeholder="" formControlName="addressOne" required>
            <div class="validation-errors mb-2">
                <ng-container *ngFor="let validation of address_validation_messages.addressOne">
                  <div class="error-message" *ngIf="createAddressForm.get('addressOne')?.hasError(validation.type) && (createAddressForm.get('addressOne')?.dirty || createAddressForm.get('addressOne')?.touched)">
                    {{ validation.message }}
                  </div>
                </ng-container>
            </div>
        </div>
    </div>
    <div class="row mt-2">
        <div class="col-md">
            <label for="address_two">Address2</label>
            <input type="text" class="form-control" id="address_two" placeholder="" formControlName="addressTwo">
            <div class="validation-errors mb-2">
                <ng-container *ngFor="let validation of address_validation_messages.addressTwo">
                  <div class="error-message" *ngIf="createAddressForm.get('addressTwo')?.hasError(validation.type) && (createAddressForm.get('addressTwo')?.dirty || createAddressForm.get('addressTwo')?.touched)">
                    {{ validation.message }}
                  </div>
                </ng-container>
            </div>
        </div>
    </div>
    <div class="row g-2 mt-2">
        <div class="col-md">
            <label for="ad_country">Country</label>
            <input type="text" class="form-control" id="ad_country" placeholder="" formControlName="adCountry" required>
            <div class="validation-errors mb-2">
                <ng-container *ngFor="let validation of address_validation_messages.adCountry">
                  <div class="error-message" *ngIf="createAddressForm.get('adCountry')?.hasError(validation.type) && (createAddressForm.get('adCountry')?.dirty || createAddressForm.get('adCountry')?.touched)">
                    {{ validation.message }}
                  </div>
                </ng-container>
            </div>
        </div>
        <div class="col-md">
            <label for="ad_state">State</label>
            <input type="text" class="form-control" id="ad_state" placeholder="" formControlName="adState" required>
            <div class="validation-errors mb-2">
                <ng-container *ngFor="let validation of address_validation_messages.adState">
                  <div class="error-message" *ngIf="createAddressForm.get('adState')?.hasError(validation.type) && (createAddressForm.get('adState')?.dirty || createAddressForm.get('adState')?.touched)">
                    {{ validation.message }}
                  </div>
                </ng-container>
            </div>
        </div>
    </div>

    <div class="row g-2 mt-2">
        <div class="col-md">
            <label for="ad_city">City</label>
            <input type="text" class="form-control" id="ad_city" placeholder="" formControlName="adCity" required>
            <div class="validation-errors mb-2">
                <ng-container *ngFor="let validation of address_validation_messages.adCity">
                  <div class="error-message" *ngIf="createAddressForm.get('adCity')?.hasError(validation.type) && (createAddressForm.get('adCity')?.dirty || createAddressForm.get('adCity')?.touched)">
                    {{ validation.message }}
                  </div>
                </ng-container>
            </div>
        </div>
        <div class="col-md">
            <label for="ad_zip">Zip</label>
            <input type="text" class="form-control" id="ad_zip" placeholder="" formControlName="adZip" required>
            <div class="validation-errors mb-2">
                <ng-container *ngFor="let validation of address_validation_messages.adZip">
                  <div class="error-message" *ngIf="createAddressForm.get('adZip')?.hasError(validation.type) && (createAddressForm.get('adZip')?.dirty || createAddressForm.get('adZip')?.touched)">
                    {{ validation.message }}
                  </div>
                </ng-container>
            </div>
        </div>
    </div>

    <div class="row g-2 mt-2">
        <div class="col-md">
            <label for="ad_phone">Phone</label>
            <input type="text" class="form-control" id="ad_phone" placeholder="" formControlName="adPhone" required>
            <div class="validation-errors mb-2">
                <ng-container *ngFor="let validation of address_validation_messages.adPhone">
                  <div class="error-message" *ngIf="createAddressForm.get('adPhone')?.hasError(validation.type) && (createAddressForm.get('adPhone')?.dirty || createAddressForm.get('adPhone')?.touched)">
                    {{ validation.message }}
                  </div>
                </ng-container>
            </div>
        </div>
        <div class="col-md">
        </div>
    </div>
    <div class="mt-4 mb-4 text-center">
        <button type="button" class="btn btn-warning btn-min-wt" [disabled]="!createAddressForm.valid" (click)="addAddress()"><b>Add</b></button>
        <button type="button" class="btn btn-danger btn-min-wt"(click)="cancelAddress()" style="margin-left: 15px;"><b>Cancel</b></button>
    </div>
    </form>
</section>
